import { memo, SyntheticEvent } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';

interface MarkedAutocompleteProps {
  label: string;
  value: string[];
  options: string[];
  onChange: (values: string[]) => void;
  required?: boolean;
}

export const MarkedAutocomplete = memo<MarkedAutocompleteProps>(({ label, value, options, onChange, required }) => {
  const handleChange = (_: SyntheticEvent, v: string[]) => {
    onChange(v);
  };

  return (
    <Autocomplete
      value={value}
      options={options}
      renderTags={(value: string[], getTagProps) =>
        value.map((option: string, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return <Chip key={key} variant="outlined" label={option} {...tagProps} />;
        })
      }
      renderInput={(params) => <TextField {...params} label={`${label} ${required && '*'}`} />}
      onChange={handleChange}
      multiple
      freeSolo
      fullWidth
    />
  );
});

MarkedAutocomplete.displayName = 'MarkedAutocomplete';
